export default __webpack_public_path__ + "static/media/homeTennis.74bc026f.png";